import React from 'react'

const Image = React.forwardRef(({ size = [500, 500], dataURL, grayscale, blur, ...props }, ref) => {
  const getFilterStyle = () => {
    const filters = []
    if (grayscale) filters.push('grayscale(100%)')
    if (blur) filters.push('blur(16px)')
    return filters.length > 0 ? filters.join(' ') : undefined
  }

  const styles = {
    filter: getFilterStyle()
  }
  
  return (
    <image
      ref={ref}
      href={dataURL}
      x={0}
      y={0}
      width={size[0]}
      height={size[1]}
      viewBox={`0 0 ${size[0]} ${size[1]}`}
      style={styles}
      {...props}
    />
  )
})

export default Image